module.exports = __webpack_public_path__ + "img/1.4f1c9c6f.png";